module.exports = __webpack_public_path__ + "img/soccerboard13.4985cf12.jpg";